import React from 'react';
import IconLink from "./../Shared/IconLink";
import { Box, Chip } from "@mui/material";

function PortfolioBlock(props)
{

   const MAX_TITLE_LENGTH_LARGE = 20;
   const MAX_TITLE_LENGTH_SMALL = 20;

   function kisaBaslik(baslik)
   {
      const windowWidth = window.innerWidth;

      const maksimumKarakter =
         windowWidth >= 1000 ? MAX_TITLE_LENGTH_LARGE : MAX_TITLE_LENGTH_SMALL;

      if (baslik.length <= maksimumKarakter)
      {
         return baslik;
      }

      let kisalmisBaslik = baslik.slice(0, maksimumKarakter);

      const sonKelimeOncesiBosluk = kisalmisBaslik.lastIndexOf(" ");

      if (sonKelimeOncesiBosluk !== -1)
      {
         kisalmisBaslik = kisalmisBaslik.slice(0, sonKelimeOncesiBosluk);
      }

      return kisalmisBaslik + '...';
   }

   const { image, source, title, tags } = props;

   const kisaltilmisText = kisaBaslik(title);

   return (
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
         <Box component={'img'} src={image} width={'90%'} />
         <h1 style={{ fontSize: '1.5rem' }}>{kisaltilmisText}</h1>
         <Box className={'portfolio'} display={'flex'} flexDirection={'column'} gap={'0.5rem'}
            alignItems={'center'} fontSize={'1.5rem'} py={'2rem'}>
            <Box className={'portfolio'} display={'flex'} flexDirection={'column'} gap={'0.5rem'} alignItems={'center'} fontSize={'1.5rem'}
               py={'1srem'}>
               <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
                  <IconLink link={source} title={'Source Code'} icon={'fa fa-code'} />
               </Box>
               {tags && (
                  <Box display="flex" gap={1} mt={2}>
                     <Chip label={tags} color="primary" variant="outlined" />
                  </Box>
               )}
            </Box>
         </Box>
      </Box>
   );
}

export default PortfolioBlock;